const tabs1 = [
  {
    name: '南管音樂篇',
    autor: '',
    path: 'indexDir_12',
  },
  {
    name: '北管音樂篇',
    autor: '',
    path: 'indexDir_13',
  },
  {
    name: '福佬歌謠篇',
    autor: '',
    path: 'indexDir_14',
  },
  {
    name: '客家音樂篇',
    autor: '',
    path: 'indexDir_15',
  },
  {
    name: '原住民音樂篇',
    autor: '',
    path: 'indexDir_16',
  },
  {
    name: '佛教、釋教音樂篇',
    autor: '',
    path: 'indexDir_17',
  },
  {
    name: '道教、法教音樂篇',
    autor: '',
    path: 'indexDir_18',
  },
  // {
  //   name: '釋奠樂篇',
  //   autor: '',
  //   path: 'indexDir_23',
  // },
  {
    name: '國樂篇',
    autor: '',
    path: 'indexDir_19',
  },
  {
    name: '西樂及混合編制篇',
    autor: '',
    path: 'indexDir_20',
  },
  {
    name: '流行音樂篇',
    autor: '',
    path: 'indexDir_21',
  },
  {
    name: '跨界音樂與其他篇',
    autor: '',
    path: 'indexDir_22',
  },
];
const tabs2 = [
  {
    name: '南管音樂篇',
    autor: '',
    path: 'indexDir_1',
  },
  {
    name: '北管音樂篇',
    autor: '',
    path: 'indexDir_2',
  },
  {
    name: '福佬歌謠篇',
    autor: '',
    path: 'indexDir_3',
  },
  {
    name: '客家音樂篇',
    autor: '',
    path: 'indexDir_4',
  },
  {
    name: '原住民音樂篇',
    autor: '',
    path: 'indexDir_5',
  },
  {
    name: '佛教、釋教音樂篇',
    autor: '',
    path: 'indexDir_6',
  },
  {
    name: '道教、法教音樂篇',
    autor: '',
    path: 'indexDir_7',
  },
  // {
  //   name: '釋奠樂篇',
  //   autor: '',
  //   path: 'indexDir_24',
  // },
  {
    name: '國樂篇',
    autor: '',
    path: 'indexDir_8',
  },
  {
    name: '西樂及混合編制篇',
    autor: '',
    path: 'indexDir_9',
  },
  {
    name: '流行音樂篇',
    autor: '',
    path: 'indexDir_10',
  },
  {
    name: '跨界音樂與其他篇',
    autor: '',
    path: 'indexDir_11',
  },
];
const tabs3 = [
  {
    name: '第三十三屆傳藝金曲獎入圍暨得獎名單',
    autor: '',
    path: 'indexDir_25',
  },
];
const tabs4 = [
  {
    name: '南管音樂及北管音樂團體基礎概況調查表',
    autor: '',
    path: 'indexDir_26',
  },
];

export {
  tabs1, tabs2, tabs3, tabs4,
};
